import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api, setAccessToken } from "../lib/api";
import { useCapturedParams } from "../lib/cleanUrl";

// Walkthrough secure access: single-use, 15-minute sign-in link for the DISPOSABLE walkthrough company only.
// The token is read once, stripped from the address bar immediately (before the network call), then verified
// server-side. Nothing is stored in localStorage/sessionStorage.
export default function WalkthroughAccess() {
  const [state, setState] = useState("idle");
  const [error, setError] = useState(null);
  const once = useRef(false);
  const { token } = useCapturedParams();  // read once; stripped from the address bar before any network call
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    if (!token) { setState("error"); setError("This page needs a sign-in link from ERF."); return; }
    setState("verifying");
    api.post("/auth/walkthrough-access/verify", { token })
      .then((r) => { setAccessToken(r.data.access_token); window.location.replace("/owner"); })
      .catch((e) => {
        setState("error");
        setError(e?.response?.data?.detail?.message || "This sign-in link is invalid, already used or expired.");
      });
  }, [token]);
  return (
    <main className="min-h-screen bg-[#FEFCF7] px-6 py-16 font-nav text-erf-dark" data-testid="walkthrough-access-page">
      <div className="mx-auto max-w-md space-y-5">
        <h1 className="font-display text-4xl font-semibold">Walkthrough sign-in</h1>
        <p className="text-sm">Disposable test company (Preview only). Each link works once and expires 15 minutes after it is sent.</p>
        {state === "verifying" && <p role="status" data-testid="walkthrough-access-status">Signing you in…</p>}
        {error && <p role="alert" className="text-[#991B1B]" data-testid="walkthrough-access-error">{error}</p>}
        <Link to="/login" className="inline-flex min-h-[44px] items-center underline focus-visible:outline focus-visible:outline-2" data-testid="walkthrough-access-login-link">Go to the sign-in page</Link>
      </div>
    </main>
  );
}
